import { markInputRule, markPasteRule } from '@tiptap/core';
import { Strike } from '@tiptap/extension-strike';

/* Regexes are slightly modified versions from the original ones in the @tiptap/extension-strike package. */

/**
 * Matches a strike to a ~~strike~~ on input. Does not allow whitespace at the start or end of the text.
 */
const inputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(~~([^~\s][^~]*[^~\s]|[^~\s])~~)$/;

/**
 * Matches a strike to a ~~strike~~ on paste. Does not allow whitespace at the start or end of the text.
 */
export const pasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(~~([^~\s][^~]*[^~\s]|[^~\s])~~)/g;

export const ZyStrike = Strike.extend({
    addInputRules() {
        return [
            markInputRule({
                find: inputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },
});
